/* src/app/system-utils/change-password-form/change-password-form.component.scss */
.password-card {
  display: flex;
  flex-direction: column;
  border: 1px solid var(--tem-border);
  border-radius: var(--tem-radius);
  background: var(--tem-surface);
  overflow: hidden;
  font-family: var(--tem-font-family);
}
.card-header {
  padding: 12px 16px;
  background: var(--tem-surface-2);
  border-bottom: 1px solid var(--tem-border);
}
.card-title {
  font-size: var(--tem-fs-lg, 16px);
  font-weight: 600;
  color: var(--tem-ink);
}
.card-body {
  padding: 16px;
}
.content {
  width: 100%;
  display: flex;
  height: 100%;
  flex-direction: column;
  gap: 10px;
}
.sideLeftPassWord {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.sideRightPassWord {
  width: 100%;
}
.col {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  font-size: var(--tem-fs-sm, 12px);
}
.text-danger {
  color: var(--tem-danger, #ff4d4f);
}
.text-success {
  color: #52c41a;
}
.eye-toggle {
  cursor: pointer;
  color: var(--tem-muted);
}
.eye-toggle:hover {
  color: var(--tem-ink);
}
.field-error {
  color: var(--tem-danger, #ff4d4f);
  font-size: var(--tem-fs-sm, 12px);
  padding-top: 2px;
}
.hide {
  display: none;
}
.button-content {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 12px 16px;
  border-top: 1px solid var(--tem-border);
}
.spacer {
  flex: 1;
}
/*# sourceMappingURL=change-password-form.component.css.map */
